import { all, takeLatest, put, call } from 'redux-saga/effects';
import qs from 'qs';
import { request } from '../../utils/http';
import {
  RESOURCES_REQUEST,
  RESOURCES_ME_REQUEST,
  RESOURCES_SUCCESS,
  RESOURCES_ERROR,
  RESOURCES_ME_ERROR,
  RESOURCES_ME_SUCCESS,
  RESOURCE_TYPE_REQUEST,
  RESOURCE_TYPE_SUCCESS,
  RESOURCE_TYPE_ERROR,
} from '../reducers/Resources';
import { getSimplifiedError } from '../../utils/error';

function getMyResources() {
  return request.get(`/resources/`);
}

function* handleGetMyResources() {
  try {
    const { data } = yield call(getMyResources);
    yield put({
      type: RESOURCES_ME_SUCCESS,
      list: data,
    });
  } catch (error) {
    yield put({
      type: RESOURCES_ME_ERROR,
      error:
        getSimplifiedError(error) ||
        'Something went wrong, Please try again later',
    });
  }
}

// function getResources({ value, query = {} }) {
//   let params = {
//     page_size: 10,
//   };
//   if (value) {
//     params.resource_types = parseInt(value);
//   }
//   return request.get(`/resources/?${qs.stringify(query)}`, { params });
// }

function getResources({ value, query = {} }) {
  const params = { ...(query || {}) };
  if (value != null && value !== '') {
    params.resource_type = Number(value);   
  }
  if (!('page_size' in params) && !('limit' in params)) {
    params.page_size = 1000;           
  }
   return request.get('/resources/', { params });
}

function* handleGetResources({ value, query }) {
  try {
    const { data } = yield call(getResources, { value, query });
    yield put({
      type: RESOURCES_SUCCESS,
      list: data,
    });
  } catch (error) {
    yield put({
      type: RESOURCES_ERROR,
      error:
        getSimplifiedError(error) ||
        'Something went wrong, Please try again later',
    });
  }
}

function getResourceTypes() {
  return request.get(`/resources/resource_types/`);
}

function* handleGetResourceTypes() {
  try {
    const { data } = yield call(getResourceTypes);
    yield put({
      type: RESOURCE_TYPE_SUCCESS,
      data,
    });
  } catch (error) {
    yield put({
      type: RESOURCE_TYPE_ERROR,
      error:
        getSimplifiedError(error) ||
        'Something went wrong, Please try again later',
    });
  }
}

export default all([
  takeLatest(RESOURCES_REQUEST, handleGetResources),
  takeLatest(RESOURCES_ME_REQUEST, handleGetMyResources),
  takeLatest(RESOURCE_TYPE_REQUEST, handleGetResourceTypes),
]);
